import { render, staticRenderFns } from "./updated.vue?vue&type=template&id=58efa813&"
import script from "./updated.vue?vue&type=script&lang=js&"
export * from "./updated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports